import { createClient } from '@supabase/supabase-js';
import { captureRecoveryFromUrl, markRecovery, clearRecovery } from './passwordRecovery';

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL || 'https://placeholder.supabase.co';
const supabaseKey = process.env.REACT_APP_SUPABASE_ANON_KEY || 'placeholder_key';

// A password-reset link must be noticed before createClient() reads and strips
// the URL hash (see lib/passwordRecovery.js).
captureRecoveryFromUrl();

export const supabase = createClient(supabaseUrl, supabaseKey);

supabase.auth.onAuthStateChange((event) => {
  if (event === 'PASSWORD_RECOVERY') markRecovery();
  else if (event === 'SIGNED_OUT') clearRecovery();
});

// PostgREST caps every response at `max_rows` (1000 on this project), so a
// single .range(0, 99999) silently returns only the first 1000 rows. This
// helper pages through the full result set in chunks so the whole catalogue
// loads regardless of the server cap.
//
// `buildQuery(lo, hi)` must return a fresh Supabase query for the given range,
// e.g. (lo, hi) => supabase.from('products').select('*').range(lo, hi).
// IMPORTANT: order by a UNIQUE column (id) so pages don't overlap/skip when
// many rows share the same created_at (common after a bulk import).
export async function fetchAllRows(buildQuery, pageSize = 1000) {
  let from = 0;
  const all = [];
  for (;;) {
    const { data, error } = await buildQuery(from, from + pageSize - 1);
    if (error) throw error;
    const rows = data || [];
    all.push(...rows);
    if (rows.length < pageSize) break;
    from += pageSize;
  }
  return all;
}
